export default "__VITE_ASSET__CTU33zl7__"